var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReportInprogress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1385_5790)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1385_5790",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 0H0V120H120V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1385_5790)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M60 120C93.14 120 120 93.14 120 60C120 26.86 93.14 0 60 0C26.86 0 0 26.86 0 60C0 93.14 26.86 120 60 120Z",
    fill: "#1A1B43"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.41 40.59C61.03 40.21 60.53 40 60 40H41C40.47 40 39.96 40.21 39.59 40.59C39.21 40.97 39 41.47 39 42C39 42.53 39.21 43.04 39.59 43.41C39.97 43.79 40.47 44 41 44H60C60.53 44 61.04 43.79 61.41 43.41C61.79 43.03 62 42.53 62 42C62 41.47 61.79 40.96 61.41 40.59Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.56 58.58C52.18 58.2 51.68 57.99 51.15 57.99H41C40.47 57.99 39.96 58.2 39.59 58.58C39.21 58.96 39 59.46 39 59.99C39 60.52 39.21 61.03 39.59 61.4C39.97 61.78 40.47 61.99 41 61.99H51.15C51.68 61.99 52.19 61.78 52.56 61.4C52.94 61.02 53.15 60.52 53.15 59.99C53.15 59.46 52.94 58.95 52.56 58.58Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.41 76.59C61.03 76.21 60.53 76 60 76H41C40.47 76 39.96 76.21 39.59 76.59C39.21 76.97 39 77.47 39 78C39 78.53 39.21 79.04 39.59 79.41C39.97 79.79 40.47 80 41 80H60C60.53 80 61.04 79.79 61.41 79.41C61.79 79.03 62 78.53 62 78C62 77.47 61.79 76.96 61.41 76.59Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.95 76.12L83.49 67.66C86.17 63.99 86.69 59.24 85.05 55.15L86.97 44.24C87.02 43.98 87.01 43.72 86.96 43.46C86.9 43.2 86.8 42.96 86.64 42.75C86.34 42.32 85.87 42.02 85.35 41.93L75 40.11V34.02C75 33.49 74.79 32.98 74.41 32.61C74.03 32.23 73.53 32.02 73 32.02H33C32.47 32.02 31.96 32.23 31.59 32.61C31.21 32.99 31 33.49 31 34.02V86.02C31 86.55 31.21 87.06 31.59 87.43C31.97 87.81 32.47 88.02 33 88.02H73C73.53 88.02 74.04 87.81 74.41 87.43C74.79 87.05 75 86.55 75 86.02V81.25L78.31 81.83C78.42 81.85 78.54 81.86 78.66 81.86C79.13 81.86 79.58 81.69 79.94 81.39C80.3 81.09 80.54 80.67 80.62 80.21L82.08 71.94L89.11 78.97C89.5 79.36 90.01 79.56 90.52 79.56C91.03 79.56 91.54 79.36 91.93 78.97C92.71 78.19 92.71 76.92 91.93 76.14L91.95 76.12ZM79.36 66.36C75.85 69.87 70.14 69.87 66.63 66.36C63.12 62.85 63.12 57.14 66.63 53.63C68.38 51.88 70.69 51 72.99 51C75.29 51 77.6 51.88 79.35 53.63C82.86 57.14 82.86 62.85 79.35 66.36H79.36ZM82.68 45.51L81.81 50.46C79.85 48.65 77.47 47.55 75 47.17V44.15L82.68 45.5V45.51ZM35 84V36H71V47.17C68.37 47.58 65.83 48.78 63.81 50.8C58.74 55.87 58.74 64.12 63.81 69.18C65.83 71.2 68.37 72.41 71 72.81V83.98H35V84ZM75 77.17V72.84C76.03 72.68 77.04 72.39 78.02 71.98L77.04 77.53L75 77.17Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.41 49.59C57.03 49.21 56.53 49 56 49H41C40.47 49 39.96 49.21 39.59 49.59C39.21 49.97 39 50.47 39 51C39 51.53 39.21 52.04 39.59 52.41C39.97 52.79 40.47 53 41 53H56C56.53 53 57.04 52.79 57.41 52.41C57.79 52.03 58 51.53 58 51C58 50.47 57.79 49.96 57.41 49.59Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.41 67.59C57.03 67.21 56.53 67 56 67H41C40.47 67 39.96 67.21 39.59 67.59C39.21 67.97 39 68.47 39 69C39 69.53 39.21 70.04 39.59 70.41C39.97 70.79 40.47 71 41 71H56C56.53 71 57.04 70.79 57.41 70.41C57.79 70.03 58 69.53 58 69C58 68.47 57.79 67.96 57.41 67.59Z",
    fill: "#1A1B43"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1385_5790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportInprogress);
export default __webpack_public_path__ + "static/media/icon-report-inprogress.0b129b2ac29e1ed41c84fd348d14cc85.svg";
export { ForwardRef as ReactComponent };